import { useEffect, useRef, useState } from "react";

export function useInputPositionTracker({ studentInputs, currentSlideIndex }) {
  const [inputPositions, setInputPositions] = useState({});
  const inputPositionsRef = useRef({});

  useEffect(() => {
    const updateInputPositions = () => {
      const inputBoxes = document.querySelectorAll("div[data-input-key]");
      const positions = {};
      inputBoxes.forEach((box) => {
        const inputKey = box.dataset.inputKey;
        const rect = box.getBoundingClientRect();
        positions[inputKey] = {
          top: rect.top,
          left: rect.left,
          width: rect.width,
          height: rect.height,
        };
      });

      const prev = inputPositionsRef.current;
      const keys = Object.keys(positions);
      const changed =
        keys.length !== Object.keys(prev).length ||
        keys.some(
          (key) =>
            !prev[key] ||
            prev[key].top !== positions[key].top ||
            prev[key].left !== positions[key].left ||
            prev[key].width !== positions[key].width ||
            prev[key].height !== positions[key].height,
        );

      if (changed) {
        inputPositionsRef.current = positions;
        setInputPositions(positions);
      }
    };

    updateInputPositions();
    const interval = setInterval(updateInputPositions, 500);
    window.addEventListener("scroll", updateInputPositions);
    window.addEventListener("resize", updateInputPositions);

    return () => {
      clearInterval(interval);
      window.removeEventListener("scroll", updateInputPositions);
      window.removeEventListener("resize", updateInputPositions);
    };
  }, [studentInputs, currentSlideIndex]);

  return inputPositions;
}
